import React, { useState } from 'react';
import Button from './ui/Button';
import Icon from './AppIcon';
import CollectDataLauncher from './CollectDataLauncher';

// ---------------------------------------------------------------------------
// CollectDataButton
//
// A single call-to-action + attached launcher, meant to be dropped into
// any page header without extra wiring. Callers only care about "put a
// Collect Data button here" — this component handles the modal state.
//
// Props are passed through to the launcher:
//   modes             ['behavior', 'iep']  (default) — restricts the flows
//   label             string, defaults to "Collect Data"
//   variant           'default' | 'outline' | 'ghost' (default 'default')
//   size              'sm' | 'md' | 'lg' (defaults to Button's own default)
//   defaultStudentId  string
//   className         string
// ---------------------------------------------------------------------------

const CollectDataButton = ({
  modes,
  label = 'Collect Data',
  variant = 'default',
  size,
  defaultStudentId = '',
  className = '',
  iconName = 'ClipboardEdit',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant={variant}
        size={size}
        onClick={() => setIsOpen(true)}
        className={className}
      >
        <Icon name={iconName} size={16} className="mr-2" />
        {label}
      </Button>
      <CollectDataLauncher
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        modes={modes}
        defaultStudentId={defaultStudentId}
      />
    </>
  );
};

export default CollectDataButton;
